import { render, staticRenderFns } from "./Platforms.vue?vue&type=template&id=0e82a1ff&scoped=true"
import script from "./Platforms.vue?vue&type=script&lang=js"
export * from "./Platforms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82a1ff",
  null
  
)

export default component.exports